<mat-card class="card1">
   
       
            <img src="https://discoveryrestaurant.in/img/sliderImage/1540398058.jpg" class="img1">
            <mat-card-title> <div class="col-xs-1" align="center"> Nature Restaurent
            </div>        </mat-card-title>
    
</mat-card>
<mat-card class="menu">
   
    <div class="row">
  <div class="col-md-9" style="padding-top: 9px;"> 
        MENU ITEM
    </div>
  <div class="col-md-3">
      <button mat-button class="btn">ADD DISH</button> 
</div>
</div>
<div class="row">
   
</div>

</mat-card>

<div class="row">
    <div class="col-md-3">
<mat-card class="dish"> <a href="#" class="badge badge-success">v</a>
    <img src="https://5.imimg.com/data5/NI/IH/QU/ANDROID-90366522/img-20190619-153251-jpg-500x500.jpg" class="img-fluid" alt="Responsive image">
    <mat-card-subtitle> <div class="col-xs-1" align="center" > Nature Restaurent<br>$47
    </div>        </mat-card-subtitle>
</mat-card>
</div>
<div class="col-md-3">
    <mat-card class="dish"> <a href="#" class="badge badge-success">v</a>
        <img src="https://5.imimg.com/data5/NI/IH/QU/ANDROID-90366522/img-20190619-153251-jpg-500x500.jpg" class="img-fluid" alt="Responsive image">
        <mat-card-subtitle> <div class="col-xs-1" align="center" > Chocolate Cake<br>$47
        </div>        </mat-card-subtitle>
    </mat-card>
    </div>
    <div class="col-md-3">
        <mat-card class="dish"> <a href="#" class="badge badge-success">v</a>
            <img src="https://5.imimg.com/data5/NI/IH/QU/ANDROID-90366522/img-20190619-153251-jpg-500x500.jpg" class="img-fluid" alt="Responsive image">
            <mat-card-subtitle> <div class="col-xs-1" align="center" > Chocolate Cake<br>$47
            </div>        </mat-card-subtitle>
        </mat-card>
        </div>
        <div class="col-md-3">
            <mat-card class="dish"> <a href="#" class="badge badge-success">v</a>
                <img src="https://5.imimg.com/data5/NI/IH/QU/ANDROID-90366522/img-20190619-153251-jpg-500x500.jpg" class="img-fluid" alt="Responsive image">
                <mat-card-subtitle> <div class="col-xs-1" align="center" > Chocolate Cake<br>$47
                </div>        </mat-card-subtitle>
            </mat-card>
            </div>
            <div class="col-md-3">
                <mat-card class="dish"> <a href="#" class="badge badge-success">v</a>
                    <img src="https://5.imimg.com/data5/NI/IH/QU/ANDROID-90366522/img-20190619-153251-jpg-500x500.jpg" class="img-fluid" alt="Responsive image">
                    <mat-card-subtitle> <div class="col-xs-1" align="center" > Chocolate Cake<br>$47
                    </div>        </mat-card-subtitle>
                </mat-card>
                </div>
                <div class="col-md-3">
                    <mat-card class="dish"> <a href="#" class="badge badge-success">v</a>
                        <img src="https://5.imimg.com/data5/NI/IH/QU/ANDROID-90366522/img-20190619-153251-jpg-500x500.jpg" class="img-fluid" alt="Responsive image">
                        <mat-card-subtitle> <div class="col-xs-1" align="center" > Chocolate Cake<br>$47
                        </div>        </mat-card-subtitle>
                    </mat-card>
                    </div>
                    <div class="col-md-3">
                        <mat-card class="dish"> <a href="#" class="badge badge-success">v</a>
                            <img src="https://5.imimg.com/data5/NI/IH/QU/ANDROID-90366522/img-20190619-153251-jpg-500x500.jpg" class="img-fluid" alt="Responsive image">
                            <mat-card-subtitle> <div class="col-xs-1" align="center" > Chocolate Cake<br>$47
                            </div>        </mat-card-subtitle>
                        </mat-card>
                        </div>
                        <div class="col-md-3">
                            <mat-card class="dish"> <a href="#" class="badge badge-success">v</a>
                                <img src="https://5.imimg.com/data5/NI/IH/QU/ANDROID-90366522/img-20190619-153251-jpg-500x500.jpg" class="img-fluid" alt="Responsive image">
                                <mat-card-subtitle> <div class="col-xs-1" align="center" > Chocolate Cake<br>$47
                                </div>        </mat-card-subtitle>
                            </mat-card>
                            </div>
</div>
